import { gql } from 'urql'
export const FragSeriesIndexInfoPageSection = gql`
  fragment SeriesIndexInfoPageSection on SeriesIndexInfoPageSection {
    content {
      title
    }
  }
`
